import { Controller } from "@hotwired/stimulus"

// Date navigation for the super_admin finanzas dashboard.
// Mirrors super_admin_dashboard_controller but defaults the tab to "resumen".
export default class extends Controller {
  static values = { period: String }

  previousPeriod(event) {
    event.preventDefault()
    this.navigatePeriod(-1)
  }

  nextPeriod(event) {
    event.preventDefault()
    this.navigatePeriod(1)
  }

  goToToday(event) {
    event.preventDefault()
    const urlParams = new URLSearchParams(window.location.search)
    const period = urlParams.get('period') || 'monthly'
    const tab = urlParams.get('tab') || 'resumen'
    const today = this.getUTCDateString(new Date())

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', today)
    newUrl.searchParams.set('period', period)
    newUrl.searchParams.set('tab', tab)
    window.location.href = newUrl.toString()
  }

  // Cambia la fecha de referencia del gráfico de evolución de precio de bandeja.
  // Preserva period/date y fuerza el tab de facturación.
  setRefDate(event) {
    const value = event.target.value
    if (!value) return

    const urlParams = new URLSearchParams(window.location.search)
    const period = urlParams.get('period') || 'monthly'
    const date = urlParams.get('date') || this.getUTCDateString(new Date())

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', date)
    newUrl.searchParams.set('period', period)
    newUrl.searchParams.set('tab', 'facturacion')
    newUrl.searchParams.set('ref_date', value)
    window.location.href = newUrl.toString()
  }

  // Selecciona un proveedor en el tab ICI para ver su drill-down.
  // Preserva period/date y fuerza el tab ici. Valor vacío = ver todos.
  setIciSupplier(event) {
    const value = event.target.value
    const urlParams = new URLSearchParams(window.location.search)
    const period = urlParams.get('period') || 'monthly'
    const date = urlParams.get('date') || this.getUTCDateString(new Date())

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', date)
    newUrl.searchParams.set('period', period)
    newUrl.searchParams.set('tab', 'ici')
    if (value) {
      newUrl.searchParams.set('ici_supplier_id', value)
    } else {
      newUrl.searchParams.delete('ici_supplier_id')
    }
    window.location.href = newUrl.toString()
  }

  navigatePeriod(direction) {
    const urlParams = new URLSearchParams(window.location.search)
    const period = urlParams.get('period') || this.periodValue || 'monthly'
    const currentDate = new Date(urlParams.get('date') || new Date())
    const tab = urlParams.get('tab') || 'resumen'

    let newDate = new Date(currentDate)

    switch(period) {
      case 'daily':
        newDate.setDate(currentDate.getDate() + direction)
        break
      case 'weekly':
        newDate.setDate(currentDate.getDate() + (7 * direction))
        break
      case 'monthly':
        newDate.setMonth(currentDate.getMonth() + direction)
        break
    }

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', this.getUTCDateString(newDate))
    newUrl.searchParams.set('period', period)
    newUrl.searchParams.set('tab', tab)
    window.location.href = newUrl.toString()
  }

  getUTCDateString(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}
